import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  ion-content {
    .content-wrapper {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 48px 16px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 10;
    }

    .app-logo {
      margin-bottom: 20px;
    }
  }
`;

export const FooterContainerStyles = styled.div`
  width: 100%;
  padding: 0 0 34px;
`;

export const PageTitleStyles = styled(UiTypography)`
  margin: 0 0 20px;
  font-weight: 600;
  font-size: 24px;
  leading-trim: NONE;
  line-height: 32px;
  letter-spacing: 0%;
  text-align: center;
`;

export const BgImageStyles = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  z-index: 1;
`;

export const OverlayGradientStyles = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  pointer-events: none;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 52.81%,
    rgba(5, 1, 14, 0.84) 70.83%,
    #0a021a 80.49%,
    #1f0650 100%
  );
`;
